export const buildContactWhatsAppMessage = ({ t, formData, pricingRegion }) => [
  t('form.contactIntro'),
  '',
  `${t('form.name')}: ${formData.name}`,
  `${t('form.business')}: ${formData.business}`,
  `${t('form.email')}: ${formData.email}`,
  formData.phone ? `${t('form.phone')}: ${formData.phone}` : null,
  formData.message ? `${t('form.project')}: ${formData.message}` : null,
  pricingRegion ? `Pricing region: ${pricingRegion.id}` : null,
  pricingRegion ? `Currency: ${pricingRegion.currencyCode}` : null,
].filter(Boolean).join('\n');

const industryMessageCopy = {
  en: {
    intro: 'Hi Webouse, I would like to discuss an industry solution.',
    industry: 'Industry',
    page: 'Page',
    name: 'Name',
    business: 'Business',
    email: 'Email',
    phone: 'Phone',
    goal: 'Main goal',
    packageInterest: 'Package interest',
    region: 'Pricing region',
    currency: 'Currency',
    reference: 'Project reference',
  },
  tr: {
    intro: 'Merhaba Webouse, sektörüm için bir çözüm görüşmek istiyorum.',
    industry: 'Sektör',
    page: 'Sayfa',
    name: 'Ad',
    business: 'İşletme',
    email: 'E-posta',
    phone: 'Telefon',
    goal: 'Ana hedef',
    packageInterest: 'Paket tercihi',
    region: 'Fiyat bölgesi',
    currency: 'Para birimi',
    reference: 'Proje referansı',
  },
  es: {
    intro: 'Hola Webouse, me gustaría hablar sobre una solución para mi sector.',
    industry: 'Sector',
    page: 'Página',
    name: 'Nombre',
    business: 'Empresa',
    email: 'Email',
    phone: 'Teléfono',
    goal: 'Objetivo principal',
    packageInterest: 'Paquete de interés',
    region: 'Región de precios',
    currency: 'Moneda',
    reference: 'Referencia del proyecto',
  },
  fr: {
    intro: 'Bonjour Webouse, je souhaite discuter d’une solution pour mon secteur.',
    industry: 'Secteur',
    page: 'Page',
    name: 'Nom',
    business: 'Entreprise',
    email: 'E-mail',
    phone: 'Téléphone',
    goal: 'Objectif principal',
    packageInterest: 'Forfait envisagé',
    region: 'Région tarifaire',
    currency: 'Devise',
    reference: 'Référence du projet',
  },
  de: {
    intro: 'Hallo Webouse, ich möchte eine Branchenlösung besprechen.',
    industry: 'Branche',
    page: 'Seite',
    name: 'Name',
    business: 'Unternehmen',
    email: 'E-Mail',
    phone: 'Telefon',
    goal: 'Hauptziel',
    packageInterest: 'Paketinteresse',
    region: 'Preisregion',
    currency: 'Währung',
    reference: 'Projektreferenz',
  },
  pt: {
    intro: 'Olá Webouse, gostaria de conversar sobre uma solução para meu setor.',
    industry: 'Setor',
    page: 'Página',
    name: 'Nome',
    business: 'Empresa',
    email: 'E-mail',
    phone: 'Telefone',
    goal: 'Objetivo principal',
    packageInterest: 'Pacote de interesse',
    region: 'Região de preços',
    currency: 'Moeda',
    reference: 'Referência do projeto',
  },
  ar: {
    intro: 'مرحبًا Webouse، أود مناقشة حل مناسب لقطاع عملي.',
    industry: 'القطاع',
    page: 'الصفحة',
    name: 'الاسم',
    business: 'النشاط',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    goal: 'الهدف الرئيسي',
    packageInterest: 'الباقة المطلوبة',
    region: 'منطقة التسعير',
    currency: 'العملة',
    reference: 'مرجع مباشر',
  },
};

export const buildIndustryWhatsAppMessage = ({
  language = 'en',
  industryName,
  route,
  formData = {},
  pricingRegion,
  projectReferenceUrl,
}) => {
  const copy = industryMessageCopy[language] || industryMessageCopy.en;

  return [
    copy.intro,
    '',
    industryName ? `${copy.industry}: ${industryName}` : null,
    route ? `${copy.page}: ${route}` : null,
    formData.name ? `${copy.name}: ${formData.name}` : null,
    formData.business ? `${copy.business}: ${formData.business}` : null,
    formData.email ? `${copy.email}: ${formData.email}` : null,
    formData.phone ? `${copy.phone}: ${formData.phone}` : null,
    formData.goal ? `${copy.goal}: ${formData.goal}` : null,
    formData.packageInterest
      ? `${copy.packageInterest}: ${formData.packageInterest}`
      : null,
    pricingRegion?.id ? `${copy.region}: ${pricingRegion.id}` : null,
    pricingRegion?.currencyCode
      ? `${copy.currency}: ${pricingRegion.currencyCode}`
      : null,
    projectReferenceUrl ? `${copy.reference}: ${projectReferenceUrl}` : null,
  ].filter(Boolean).join('\n');
};
